import { createSlice } from "@reduxjs/toolkit";

interface ItabTitleState {
  updatedTitle: string;
}

const initialState: ItabTitleState = {
  updatedTitle: "",
};

export const tabTitleSlice = createSlice({
  name: "tableTitle",
  initialState,
  reducers: {
    setUpdatedTitle: (state, action) => {
      return action.payload;
    },
  },
});

export const { setUpdatedTitle } = tabTitleSlice.actions;
export const tabTitle = tabTitleSlice.reducer;
